import { render, staticRenderFns } from "./InstantChoosePack.vue?vue&type=template&id=54062bd4&"
import script from "./InstantChoosePack.vue?vue&type=script&lang=js&"
export * from "./InstantChoosePack.vue?vue&type=script&lang=js&"
import style0 from "./InstantChoosePack.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports